import { draft } from '../../resources/draft';
import { saveDraftSuccess, saveDraftError } from '../draft/actions';

import { SAVE_DRAFT } from '../constants';

const saveDraftMiddleware = ({ dispatch, getState }) => next => action => {
  const { type } = action;

  if (type !== SAVE_DRAFT) {
    return next(action);
  }

  const date = new Date().valueOf();

  const stateData = getState();
  const state = { ...stateData };

  delete state.serviceFavoriteStatus;
  delete state.requestDataSuccess;
  delete state.requestError;
  delete state.appealCancelData;
  delete state.draft;

  const data = {
    state,
    timestamp: date
  };

  if (draft) {
    draft
      .saveAuto(data)
      .then(() => dispatch(saveDraftSuccess(date)))
      .catch(() => dispatch(saveDraftError()));
  }

  return next(action);
};

export default saveDraftMiddleware;
